module.exports = __webpack_public_path__ + "assets/images/bc7c83c75d57fd0e2cd5af1208ed1b7b.png";